import { getMethods as getConnectionMethods } from './Connection';
import { getMethods as getQueryMethods } from './Query';
import { getMethods as getSAPMethods } from './SAP';

const getController = (service: 'Studio') => ({
	Connection: getConnectionMethods(service, 'DataSource/Connection'),
	Query: getQueryMethods(service, 'DataSource/Query'),
	SAP: getSAPMethods(service, 'DataSource/SAP')
});

export { getController };
